module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("Cover Design: "), _c('a', {
    attrs: {
      "href": "http://www.written-ink.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Written Ink Designs")])]), _vm._v(" | written-ink.com")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Image(s) used under a Standard Royalty-Free License.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("No portion of this book may be transmitted or reproduced in any form, or by any means, without permission from the publisher, with the exception of excerpts used for the purposes of review.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("This book is for ADULT AUDIENCES ONLY. It may contain sexually explicit scenes and graphic language which might be considered offensive by some readers. Please store your files where they cannot be accessed by minors.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("This is a work of fiction. Names, characters, places, and incidents are solely the product of the author’s imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Published in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Author’s Note: Readers can read more about Jimmy, Jake, and Barry in "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Cowboy Sandwich")]), _vm._v(" and "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Cowboy Sandwich 2")]), _vm._v(", both by JMS Books.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15429fa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0